@if (formActivityVisible && reviewMode) {
  <div
    style="
      top: 0rem;
      right: 0rem;
      background-color: #f5f6f6;
      height: auto;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      position: absolute;
      width: 23%;
      padding: 0rem;
    "
  >
    <div style="margin-left: 1.5rem; margin-top: 1.5rem">
      <div style="text-align: right; margin-bottom: -1.375rem; margin-right: 1.438rem">
        <span (click)="toggleFormActivity()" class="closeButton">&#10005;</span>
      </div>
      @if (formStatusTimeline.readyForReview) {
        <div style="margin-bottom: 1rem">
          <span style="font-size: 1.125rem; color: #4c4c4c"
            >The form is ready for your review.</span
          >
        </div>
      }
      @if (formStatusTimeline.beingReviewed) {
        <div style="margin-bottom: 1rem">
          <span style="font-size: 1.125rem; color: #4c4c4c">The form is being reviewed.</span>
        </div>
      }
      @if (formStatusTimeline.youRejectedForm) {
        <div style="margin-bottom: 1rem">
          <span style="font-size: 1.125rem; color: #4c4c4c">You have rejected the form.</span>
        </div>
      }
      @if (formStatusTimeline.formRejected) {
        <div style="margin-bottom: 1rem">
          <span style="font-size: 1.125rem; color: #4c4c4c">The form has been rejected.</span>
        </div>
      }
      @if (formStatusTimeline.youApprovedForm) {
        <div style="margin-bottom: 1rem">
          <span style="font-size: 1.125rem; color: #4c4c4c">You have approved the form.</span>
        </div>
      }
      @if (formStatusTimeline.formCompleted) {
        <div style="margin-bottom: 1rem">
          <span style="font-size: 1.125rem; color: #4c4c4c">The form has been completed.</span>
        </div>
      }
      @if (formStatusTimeline.readyForReview) {
        <div>
          <textarea
            [ngModel]="reviewComments"
            (ngModelChange)="onReviewCommentsChange($event)"
            class="scopeDescriptionTextBox2"
            placeholder="Comments (optional)"
          ></textarea>
        </div>
      }
      @if (formStatusTimeline.readyForReview) {
        <div style="display: inline-block; padding-bottom: 1.5rem; margin-top: 1.25rem">
          <button (click)="approveForm(true)" class="rejectButton">
            <span class="confirmText">REJECT</span>
          </button>
        </div>
      }
      @if (formStatusTimeline.readyForReview) {
        <div style="display: inline-block; padding-bottom: 1.5rem">
          <button
            (click)="approveForm()"
            class="confirmButton"
            [class.buttonDisabled]="showDerivationError"
          >
            <span class="confirmText">APPROVE</span>
          </button>
        </div>
      }
      @if (formStatusTimeline.formCompleted) {
        <div style="display: inline-block; padding-bottom: 1.5rem">
          <button (click)="onAccountingClick()" class="accountingButton">
            <span class="accountingText">ACCOUNTING</span>
          </button>
        </div>
      }
      <div style="height: 0.1rem; background-color: #b7b9ba; width: 25rem"></div>
      <!-- Form Activity Section (Hidden when accounting form is shown) -->
      @if (!showAccountingForm) {
        <div>
          <div style="margin-bottom: 1rem; margin-top: 1.5rem">
            <span style="font-size: 1.125rem; color: #4c4c4c">Form Activity</span>
          </div>
          @for (activity of formActivity; track activity) {
            <div
              style="
                background-color: #ffffff;
                width: 24.062rem;
                padding-top: 0.875rem;
                padding-left: 0.938rem;
                margin-bottom: 1rem;
              "
            >
              <div style="display: inline-block">
                @if (
                  activity.assignedBy &&
                  activity.assignedBy.givenName &&
                  activity.assignedBy.surname
                ) {
                  <span style="color: #4c4c4c"
                    >{{ activity.assignedBy.givenName }} {{ activity.assignedBy.surname }}</span
                  >
                }
                @if (
                  activity.assignedBy &&
                  !(activity.assignedBy.givenName && activity.assignedBy.surname)
                ) {
                  <span style="color: #4c4c4c">{{ activity.assignedBy.displayName }}</span>
                }
              </div>
              <div style="display: inline-block; float: right; padding-right: 1.313rem">
                @if (activity.status === 'Review') {
                  <span style="color: #4c4c4c">Submitted</span>
                }
                @if (activity.status === 'Approved') {
                  <span style="color: #00853f">{{ activity.status }}</span>
                }
                @if (activity.status === 'Approved') {
                  <img style="width: 1.063rem; margin-left: 0.313rem" src="assets/approved.svg" />
                }
                @if (activity.status === 'Rejected') {
                  <span style="color: #9e1b32">{{ activity.status }}</span>
                }
                @if (activity.status === 'Rejected') {
                  <img style="width: 1.063rem; margin-left: 0.313rem" src="assets/rejected.svg" />
                }
                @if (activity.status === 'Completed') {
                  <span style="color: #4c4c4c">{{ activity.status }}</span>
                }
                @if (activity.status === 'Completed') {
                  <img style="width: 1.063rem; margin-left: 0.313rem" src="assets/completed.svg" />
                }
                @if (activity.status === 'Added Charging Details') {
                  <span style="color: #4c4c4c; font-size: 0.875rem">{{ activity.status }}</span>
                }
                @if (activity.status === 'Made a Change') {
                  <span style="color: #4c4c4c; font-size: 0.875rem">{{ activity.status }}</span>
                }
                @if (activity.status === 'Resubmitted') {
                  <span style="color: #4c4c4c">{{ activity.status }}</span>
                }
              </div>
              <div>
                <span style="color: #696969; font-size: 0.875rem">{{ activity.date }}</span>
              </div>
              <div style="width: 95%; padding-bottom: 1rem">
                <span style="color: #4c4c4c; font-size: 0.875rem">{{ activity.comments }}</span>
              </div>
            </div>
          }
        </div>
      }
      <!-- End Form Activity Section -->
      <!-- Saved Accounting Code Block Summary (read-only, always visible once saved) -->
      @if (hasPersistedCodeBlock() && !showAccountingForm) {
        <div
          style="
            background-color: #ffffff;
            width: 24.062rem;
            padding: 0.875rem 0.938rem 1rem;
            margin-bottom: 1rem;
            border-left: 3px solid #00788a;
          "
        >
          <div style="margin-bottom: 0.5rem">
            <span style="font-size: 0.938rem; font-weight: 600; color: #4c4c4c"
              >Accounting Code Block</span
            >
          </div>
          @if (savedCodeBlock.projectId) {
            <div style="margin-bottom: 0.25rem">
              <span style="color: #696969; font-size: 0.8rem">Project ID: </span>
              <span style="color: #4c4c4c; font-size: 0.8rem">{{ savedCodeBlock.projectId }}</span>
            </div>
          }
          @if (savedCodeBlock.projectDescription) {
            <div style="margin-bottom: 0.25rem">
              <span style="color: #696969; font-size: 0.8rem">Project Description: </span>
              <span style="color: #4c4c4c; font-size: 0.8rem">{{
                savedCodeBlock.projectDescription
              }}</span>
            </div>
          }
          @if (savedCodeBlock.activityId) {
            <div style="margin-bottom: 0.25rem">
              <span style="color: #696969; font-size: 0.8rem">Activity ID: </span>
              <span style="color: #4c4c4c; font-size: 0.8rem">{{ savedCodeBlock.activityId }}</span>
            </div>
          }
          @if (savedCodeBlock.account) {
            <div style="margin-bottom: 0.25rem">
              <span style="color: #696969; font-size: 0.8rem">Account #: </span>
              <span style="color: #4c4c4c; font-size: 0.8rem">{{ savedCodeBlock.account }}</span>
            </div>
          }
          @if (savedCodeBlock.processCode) {
            <div style="margin-bottom: 0.25rem">
              <span style="color: #696969; font-size: 0.8rem">Process Code: </span>
              <span style="color: #4c4c4c; font-size: 0.8rem">{{
                savedCodeBlock.processCode
              }}</span>
            </div>
          }
          @if (savedCodeBlock.capitalOperatingUnit) {
            <div style="margin-bottom: 0.25rem">
              <span style="color: #696969; font-size: 0.8rem">Capital Operating Unit: </span>
              <span style="color: #4c4c4c; font-size: 0.8rem">{{
                savedCodeBlock.capitalOperatingUnit
              }}</span>
            </div>
          }
          @if (savedCodeBlock.omOperatingUnit) {
            <div style="margin-bottom: 0.25rem">
              <span style="color: #696969; font-size: 0.8rem">O&amp;M Operating Unit: </span>
              <span style="color: #4c4c4c; font-size: 0.8rem">{{
                savedCodeBlock.omOperatingUnit
              }}</span>
            </div>
          }
          @if (savedCodeBlock.responsibilityCenter) {
            <div style="margin-bottom: 0.25rem">
              <span style="color: #696969; font-size: 0.8rem">Responsibility Center: </span>
              <span style="color: #4c4c4c; font-size: 0.8rem">{{
                savedCodeBlock.responsibilityCenter
              }}</span>
            </div>
          }
          @if (savedCodeBlock.businessUnit) {
            <div style="margin-bottom: 0.25rem">
              <span style="color: #696969; font-size: 0.8rem">Business Unit: </span>
              <span style="color: #4c4c4c; font-size: 0.8rem">{{
                savedCodeBlock.businessUnit
              }}</span>
            </div>
          }
        </div>
      }
      <!-- End Saved Accounting Code Block Summary -->
      <!-- Accounting Form Section -->
      @if (showAccountingForm) {
        <div class="accounting-section" [formGroup]="accountingFormGroup">
          <div style="margin-bottom: 1.5rem">
            <span style="font-size: 1.125rem; color: #4c4c4c; font-weight: 500"
              >Accounting Code Block</span
            >
          </div>
          <div class="formField">
            <mat-form-field>
              <mat-label>Project ID</mat-label>
              <input matInput formControlName="projectId" readonly />
            </mat-form-field>
          </div>
          <div class="formField">
            <mat-form-field>
              <mat-label>Project Description</mat-label>
              <textarea matInput formControlName="projectDescription" rows="3" readonly></textarea>
            </mat-form-field>
          </div>
          <div class="formField">
            <mat-form-field>
              <mat-label>Activity ID</mat-label>
              <mat-select formControlName="activityId">
                <mat-option value="">Select Activity ID</mat-option>
                <mat-option value="I-Install">I-Install</mat-option>
                <mat-option value="R-Removal">R-Removal</mat-option>
                <mat-option value="OM-O&M">OM-O&M</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="formField">
            <mat-form-field>
              <mat-label>Account #</mat-label>
              <input matInput formControlName="account" />
            </mat-form-field>
          </div>
          <div class="formField">
            <mat-form-field>
              <mat-label>Process Code</mat-label>
              <input matInput formControlName="processCode" />
            </mat-form-field>
          </div>
          <div class="formField">
            <mat-form-field>
              <mat-label>Capital Operating Unit</mat-label>
              <input matInput formControlName="capitalOperatingUnit" />
            </mat-form-field>
          </div>
          <div class="formField">
            <mat-form-field>
              <mat-label>O&M Operating Unit</mat-label>
              <input matInput formControlName="omOperatingUnit" />
            </mat-form-field>
          </div>
          <div class="formField">
            <mat-form-field>
              <mat-label>Responsibility Center</mat-label>
              <input matInput formControlName="responsibilityCenter" />
            </mat-form-field>
          </div>
          <div class="formField">
            <mat-form-field>
              <mat-label>Business Unit</mat-label>
              <input matInput formControlName="businessUnit" />
            </mat-form-field>
          </div>
          <div class="accounting-actions">
            <button (click)="onCancelAccounting()" class="cancelButton">
              <span class="buttonText">CANCEL</span>
            </button>
            <button (click)="onSaveAccounting()" class="saveButton">
              <span class="buttonText">SAVE</span>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
}
